import { useRef, useState } from 'react';
import { AllPhotosHeader, AllPhotosSectionWrapper, PhotosWrapper } from '../AllPhotosSection/ui';
import styled from 'styled-components';
import { CollapseIcon } from 'components/Icons/CollapseIcon';
import { ExpandIcon } from 'components/Icons/ExpandIcon';
import { FieldArray, useFieldArray } from 'react-final-form-arrays';
import { Field, FieldRenderProps, useField } from 'react-final-form';
import { PhotoComponent } from '../components/photos';
import { ImageField } from 'services/api/upload-vehicle';
import { parseFile } from 'utils/file';
import { SaveImageFn, useUpdateImage } from '../hooks/useUpdateImage';
import { useNonBlockingImageUpload } from '../hooks/useNonBlockingImageUpload';
import { useIsOnline } from 'hooks';

const obdSectionPath = 'interior_questions.subsections.odb_check_smog_readiness';
const fillColor = 'rgba(153, 153, 153, 1)';

const IconWrapper = styled.div`
  display: flex;
`;

export const FinalReviewObdImages = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpanded = () => {
    setIsExpanded(c => !c);
  };

  return (
    <AllPhotosSectionWrapper withBorder>
      <AllPhotosHeader isExpanded={isExpanded} style={{ background: '#fff' }}>
        <IconWrapper onClick={toggleExpanded}>
          {isExpanded ? <CollapseIcon fillColor={fillColor} /> : <ExpandIcon fillColor={fillColor} />}
        </IconWrapper>
        <span>{`All OBD/Smog Readiness Pictures`}</span>
      </AllPhotosHeader>
      {isExpanded && (
        <PhotosWrapper>
          <FieldArray
            name={`${obdSectionPath}.images`}
            render={({ fields }) => {
              return fields.map((name, i) => <Field key={name} name={name} i={i} component={FinalReviewObdPhoto} />);
            }}
          />
        </PhotosWrapper>
      )}
    </AllPhotosSectionWrapper>
  );
};

const FinalReviewObdPhoto = (props: FieldRenderProps<ImageField> & { i: number }) => {
  console.log('component props', props);
  const { i } = props;
  const { fields } = useFieldArray(`${obdSectionPath}.images`);
  const localRemove = () => fields.update(i, { ...fields.value[i], url: '', url_thumb: '' });

  const {
    input: { value: notes }
  } = useField(`${obdSectionPath}.images.${i}.notes`, { subscription: { value: true } });
  const { input: localUrlInput } = useField(`${obdSectionPath}.images.${i}.local_url`);
  const { input: urlInput } = useField(`${obdSectionPath}.images.${i}.url`);

  const inputRef = useRef<HTMLInputElement>(null);
  const openFileInput = () => inputRef.current?.click();

  const isOnline = useIsOnline();

  const nonBlockingUpload = useNonBlockingImageUpload(obdSectionPath, i);
  const updateImage = useUpdateImage(obdSectionPath, i);

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async event => {
    event.preventDefault();
    const file = event.target.files?.[0];
    if (!file) return;
    const parsedFile = await parseFile(file);

    if (isOnline) {
      await nonBlockingUpload(parsedFile);
    } else {
      const payload: Parameters<SaveImageFn>[0] = {};

      payload.file = parsedFile as any;
      urlInput.onChange(null)
      localUrlInput.onChange(URL.createObjectURL(parsedFile));
      if (notes?.message) {
        payload.notes = notes?.message;
      }

      await updateImage(payload);
    }
  };

  return (
    <>
      <input
        onChange={handleFileChange}
        ref={inputRef}
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.heic"
        name={`${props.name}_file`}
        style={{ display: 'none' }}
      />
      <PhotoComponent
        onClick={openFileInput}
        localRemove={localRemove}
        withUploadLabel={false}
        displaySize="md"
        {...props}
      />
    </>
  );
};
